var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThemeProvider',{attrs:{"color":_vm.themeColor}},[_c('div',{staticClass:"inner-wrapper"},[_c('nuxt')],1),_vm._v(" "),_c('sh-footer',{attrs:{"tabindex":"-1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }